import { useQuery } from '@tanstack/react-query';
import { StorageKeys, useStorageKeys } from '../../storage';
import { useGrippContext } from '../../grippContext';
import { useCurrentWorkspace } from '../../auth';

export const useFilter = (
  queryKey: string,
  storageKey: string,
  deserializeStorage: (filter: any) => any,
  isMultiWorkspace?: boolean,
  workspaceOverride?: string
): { data: any; isLoading: boolean } => {
  const { storageHandler } = useGrippContext();
  const storageKeys = useStorageKeys();
  const currentWorkspace = useCurrentWorkspace();

  const workspace = workspaceOverride ?? (isMultiWorkspace
    ? currentWorkspace === null
      ? 'ME'
      : currentWorkspace?.id
    : undefined);

  const { data, isLoading } = useQuery<any>({
    staleTime: Infinity,
    queryKey: [queryKey, workspace],
    enabled: !isMultiWorkspace || currentWorkspace !== undefined,
    queryFn: async () => {
      const parsed = JSON.parse(
        (await storageHandler.getItem(
          storageKeys[storageKey as keyof StorageKeys]
        )) as string
      );
      let filter = parsed;
      if (isMultiWorkspace && workspace) {
        if (
          Array.isArray(parsed) &&
          parsed.every(
            (item) =>
              item &&
              typeof item === 'object' &&
              'workspace' in item &&
              'filter' in item
          )
        ) {
          // Valid new format
          const match = parsed.find((item) => item.workspace === workspace);
          if (match) {
            filter = match.filter;
          } else {
            filter = undefined;
          }
        } else {
          // Old format detected, discard
          filter = undefined;
        }
      }
      return deserializeStorage(filter);
    },
  });

  return { data, isLoading };
};
